import { PanelComponent } from './../shared/panel-switch/panel-switch.component';
import { PipesModule } from '@app/pipes/pipes.module';
import { RestaurantComponent } from './restaurant.component';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonComponentsModule } from '@app/modules/common/common.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@app/modules/shared/shared.module';
export const routes: Routes = [
    {
        path: '',
        component: RestaurantComponent,
    }
];
@NgModule({
    imports: [
        RouterModule.forChild(routes),
        CommonComponentsModule,
        FormsModule,
        CommonModule,
        PipesModule,
        SharedModule
    ],
    declarations: [
        RestaurantComponent
    ],
    exports: [
    ]
})

export class RestaurantModule {

}
